import { Injectable, signal } from '@angular/core';

export interface ConfirmDialogConfig {
    title: string;
    message: string;
    details?: string;
    confirmText?: string;
    cancelText?: string;
    type?: 'danger' | 'warning' | 'info';
}

@Injectable({ providedIn: 'root' })
export class ConfirmDialogService {
    readonly isOpen = signal(false);
    readonly config = signal<ConfirmDialogConfig>({
        title: '',
        message: '',
    });

    private resolveFn: ((value: boolean) => void) | null = null;

    /**
     * Opens a confirmation dialog and returns a Promise that resolves
     * to `true` if confirmed or `false` if cancelled.
     */
    confirm(config: ConfirmDialogConfig): Promise<boolean> {
        this.config.set({
            confirmText: 'Confirmar',
            cancelText: 'Cancelar',
            type: 'danger',
            ...config,
        });
        this.isOpen.set(true);

        return new Promise<boolean>((resolve) => {
            this.resolveFn = resolve;
        });
    }

    /** Called by the dialog component when user clicks confirm */
    onConfirm(): void {
        this.isOpen.set(false);
        this.resolveFn?.(true);
        this.resolveFn = null;
    }

    /** Called by the dialog component when user cancels */
    onCancel(): void {
        this.isOpen.set(false);
        this.resolveFn?.(false);
        this.resolveFn = null;
    }
}
